((Disclaimer, $) => {
  'use strict';

  let $disclaimer;
  let $check;
  let $agree;

  const cacheDom = () => {
    $disclaimer = $('.js-disclaimer-wrapper');
    $check = $disclaimer.find('.js-disclaimer-checkbox');
    $agree = $disclaimer.find('.js-disclaimer-agree');
  };

  const bindUIActions = () => {
    $check.on('change', function checkChange() {
      const $this = $(this);

      if ($this.is(':checked')) {
        $agree.removeClass('disclaimer-disable');
      } else {
        $agree.addClass('disclaimer-disable');
      }
    });

    $agree.on('click', function () {
      $(this).parents('.modal').find('.modal-close').click();
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  Disclaimer.init = init;
})(window.Disclaimer = window.Disclaimer || {} , jQuery);
